async function getAlerts($axios) {
  const { data } = await $axios.get('/v3/app/vacation/salesmen/alert')
  return data
}

let intervalId = null
const minute = 60 * 1000

async function runGetAlerts(ctx) {
  if (!ctx.app.store.state.auth.user) {
    clearInterval(intervalId)
    intervalId = setInterval(() => runGetAlerts(ctx), minute / 10)
    return
  }
  clearInterval(intervalId)
  const lastFetch = ctx.app.store.state.vacationRunManager.lastFetch
  const needsToRun =
    !lastFetch ||
    ctx.$moment.utc(lastFetch).isBefore(ctx.$moment.utc().startOf('day'))

  if (!needsToRun) return

  const alerts = await getAlerts(ctx.$axios)
  ctx.app.store.commit(
    'vacationRunManager/setLastFetch',
    ctx.$moment.utc().format('YYYY-MM-DD')
  )

  if (!alerts.length) return
  ctx.app.store.commit('vacation/setVacationsAlert', alerts)
}

export default async ctx => {
  runGetAlerts(ctx)
}
